export const blockIconsDeviceStorage = (
	<span className='material-symbols-outlined'>storage</span>
);
